// 简体中文

export default {
  t1: '完成',
  t5: '支付',
  t6: '绑定并授权',
}
